import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import {
  DeviceUtils,
  EntidadeInfo,
  HeaderTitle,
  KeycloakAuthHttp,
  MaskUtils,
  RolesCache,
  Sidebar
} from '@elotech/angular-common';
import { Observable, of } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import {
  FuncionarioDTO
} from '../../folha-pagamento/src/acao-coletiva/acao-coletiva-mudanca-lotacao/table/acao-coletiva-mudanca-lotacao-funcionario.service';
import {
  CentralPortalServidorService
} from '../../folha-pagamento/src/central-portal-servidor/central-portal-servidor.service';
import { AmbienteUtils } from '../../folha-pagamento/src/common/utils/ambiente-utils';
import {
  ConfiguracaoGeralRelatorioService
} from '../../folha-pagamento/src/configuracao-geral/adicionar-relatorio/configuracao-geral-relatorio.service';
import { FuncionarioService } from '../../folha-pagamento/src/funcionario/funcionario.service';
import { GruposPermitidosService } from './central-portal-servidor/grupos-permitidos.service';
import { ServidorSelecionadoService } from './common/components/funcionario-sidebar/servidor-selecionado.service';
import { EntidadeService } from './common/services/entidade.service';
import { MatriculaSidebarService } from './common/services/matriculas-sidebar.service';
import { Destroyer } from './common/utils/destroyer';
import { UsuarioService } from './usuario/usuario.service';

declare let ga: any;

const permissions = require('./keycloak/permissions.json');

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent extends Destroyer implements OnInit {
  isBloqueadoProducaoDiferenteHomologacao: boolean = false;

  urlsToLabels: any[] = [];
  toggled = true;
  userRolesLoading = true;
  showFeaturesGroup = false;
  usuarioLogado: any;
  funcionarioSelecionado: FuncionarioDTO;
  funcionarioEntidade: number;
  entidadePrincipal: EntidadeInfo;
  headerTitle: HeaderTitle = new HeaderTitle();
  isCpfFuncionario: boolean = true;
  userName: string = '';
  headerSubtitle: string = '';
  cpfCnpjFormatado: string = '';
  urlNovidades: string = 'https://atendimento.elotech.com.br/hc/pt-br/sections/4410832324371-Oxy-Portal-do-Servidor';
  brasaoByteArray: any;
  habilitarExibicaoAvaliacao: Observable<boolean> = of(false);
  habilitarExibicaoCat: Observable<boolean> = of(false);
  habilitarExibicaoPrev: Observable<boolean> = of(false);
  habilitarExibicaoRelatorios: Observable<boolean> = of(true);

  constructor(
    private _keycloak: KeycloakAuthHttp,
    private _usuarioService: UsuarioService,
    private _router: Router,
    private _entidadeService: EntidadeService,
    private _servidorSelecionadoService: ServidorSelecionadoService,
    private _funcionarioService: FuncionarioService,
    private _centralPortalServidor: CentralPortalServidorService,
    private _gruposPermitidos: GruposPermitidosService,
    private _matriculasSidebar: MatriculaSidebarService,
    private _configuracaoGeralRelatorioService: ConfiguracaoGeralRelatorioService) {
    super();
  }

  ngOnInit(): void {
    this.isBloqueadoProducaoDiferenteHomologacao = AmbienteUtils.isAmbienteProducaoDiferenteHomologacao();

    this._usuarioService.findUserInfo().subscribe(userInfo => {
      this._matriculasSidebar.setUserInfo(userInfo);
      this._keycloak.setUsuarioInfo(userInfo);

      this._setupGoogleAnalytics();
      this._initComponentData();

      this._keycloak.getUser().then(async (usuario: any) => {

        this._usuarioService.hasacessoBloqueadoDesligamentoOuFeriasOuAfastado(usuario['preferred_username']).subscribe(
          async (retorno) => {
            if (retorno.bloqueado) {
              this.userRolesLoading = false;
              await this._router.navigate(['forbidden']);
              return;
            }

            await this._matriculasSidebar.setMatriculas(usuario);

            const funcionario = this._matriculasSidebar.findFuncionarios();
            this.funcionarioEntidade = funcionario.entidade;
            if (!funcionario) {
              this.userRolesLoading = false;
              this.isCpfFuncionario = false;
              this.showFeaturesGroup = true;

              return;
            }

            this._matriculasSidebar.changeMatricula(userInfo, funcionario);

            this._usuarioService.getAllRolesUser(usuario.sub)
              .subscribe(roles => {
                RolesCache.create([...roles, ...permissions]);
                this.userRolesLoading = false;
                this.showFeaturesGroup = true;
                this.setEntidadeHeader(funcionario.entidade);
                this._gruposPermitidos.gruposPermitidos$ = this._centralPortalServidor.
                  popularGruposHabilitadosData().pipe(shareReplay(1));
                this.habilitarExibicaoAvaliacao = this._gruposPermitidos.temPermissao('AVALIACAO_DESEMPENHO');
                this.habilitarExibicaoCat = this._gruposPermitidos.temPermissao('COMUNICADO_ACIDENTE_TRABALHO');
                this.habilitarExibicaoPrev = this._gruposPermitidos.temPermissao('CONTRIBUICAO_PREVIDENCIARIA');
                this.habilitarExibicaoRelatorios = this._configuracaoGeralRelatorioService.existsRelatorioConfiguradoPortalServidor();
              });
          });
      });
    });


  }

  setEntidadeHeader(idEntidade: number) {
    if (idEntidade) {
      this._updateHeaderInfo(this._keycloak.getUsuarioInfo().entidades, idEntidade);
    }
  }

  setUrlsToLabels(sidebars) {
    this.urlsToLabels = this._addUrlsToLabes(sidebars, []);
  }

  openSideBar() {
    if (!DeviceUtils.isMobile()) {
      this.toggled = false;
    }
  }

  onInitSideBar(event: any) {
    this.setUrlsToLabels(event);
  }

  onSideBarHideRequest() {
    this.toggled = DeviceUtils.isMobile();
  }

  onClickToggled() {
    this.toggled = !this.toggled;
  }

  onLogout() {
    this._keycloak.logoutAndGoToAuthForm();
  }

  private _resolveHeaderSubtitle() {
    this.headerSubtitle = this.funcionarioSelecionado
      ? this.funcionarioSelecionado?.matricula + ' - ' + this.funcionarioSelecionado?.pessoa?.nome
      : this.userName;
    if (this.funcionarioSelecionado?.pessoa?.nomeSocial) {
      this.headerSubtitle += ' - ' + this.funcionarioSelecionado?.pessoa?.nomeSocial;
    }
  }

  private _updateHeaderInfo(entidades: EntidadeInfo[], idEntidade: number) {
    if (entidades) {
      this.entidadePrincipal = entidades.find(e => e.id === idEntidade);
      this.headerTitle.nomeEntidade = this.entidadePrincipal?.nome;
      this._setBrasaoEntidadeLogada(this.entidadePrincipal?.id);
    }
  }

  private _setBrasaoEntidadeLogada(entidadeId: number) {
    this._entidadeService.getEntidadeBrasaoById(entidadeId).subscribe(eb => {
      this.brasaoByteArray = eb.brasao || null;
    });
  }

  private _initComponentData() {

    this.usuarioLogado = this._keycloak.getUser();

    this._keycloak.getUser().then(usuario => {
      this.userName = usuario.name;

      this.cpfCnpjFormatado = MaskUtils.formatCnpjCpf(usuario.preferred_username);
      if (this.cpfCnpjFormatado.length === 0) {
        this.cpfCnpjFormatado = usuario.preferred_username;
      }

      this._funcionarioService.findFuncionariosPorCpf(usuario.preferred_username).subscribe(matricula => {
        if (matricula.length === 0) {
          this.isCpfFuncionario = false;
        }
      });
    });

    this._servidorSelecionadoService.onSelecionarFuncionario().subscribe(servidor => {
      this.funcionarioSelecionado = servidor;
      this._resolveHeaderSubtitle();
    });
  }

  private _setupGoogleAnalytics() {
    this._router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        ga('set', 'page', event.urlAfterRedirects);
        ga('send', 'pageview');
      }
    });
  }

  private _addUrlsToLabes(sidebar: Sidebar[], urls: any[] = [
    { url: 'movimentacao-pessoal', label: 'Movimentação Pessoal', icon: 'fa fa-file-text-o' },
    { url: 'licenca-premio', label: 'Licença Prêmio', icon: 'fa fa-plane' },
    { url: 'ferias', label: 'Férias', icon: 'fa fa-plane' },
    { url: 'holerite', label: 'Holerite', icon: 'fa fa-money' }
  ]) {

    sidebar.forEach(s => {
      if (s.items.length > 0) {
        this._addUrlsToLabes(s.items, urls);
      } else {
        urls.push({ url: s.route, label: s.name, icon: s.icon });
      }

    });

    return urls;
  }

}
